import { normalizeBundle } from './schema-io.mjs'
const base = process.env.VUE_APP_API_URL || (location.port === '8000' ? '/api' : 'http://127.0.0.1:8000/api')
export async function api(path, options = {}) {
  let response
  try {
    response = await fetch(base + path, {
      ...options,
      headers: { 'Content-Type': 'application/json', ...options.headers },
      signal: options.signal || AbortSignal.timeout(15000),
      body: options.body ? JSON.stringify(options.body) : undefined,
    })
  } catch (error) {
    if (options.signal?.aborted) throw error
    throw new Error(
      error.name === 'TimeoutError'
        ? '本地后端响应超时，请检查后端终端和任务状态。'
        : '无法读取本地后端响应。请检查后端终端；更新代码后请重启 npm run backend。',
      { cause: error },
    )
  }
  const data = await response.json().catch(() => null)
  if (!response.ok) {
    const error = new Error(
      typeof data?.detail === 'string'
        ? data.detail
        : response.status >= 500
          ? '后端处理请求失败，请查看后端终端；若刚更新代码，请重启 npm run backend。'
          : '后端请求失败',
    )
    error.status = response.status
    throw error
  }
  if (data === null) throw new Error('后端返回格式无效，请确认本地 API 服务地址。')
  if (data.latest) data.latest = normalizeBundle(data.latest)
  return normalizeBundle(data)
}
